// extracted by mini-css-extract-plugin
export default {"container":"Team_container__BhUDs","error":"Team_error__bv2mY"};